export class RoundCommandError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "RoundCommandError";
  }
}

export class RoundResultError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "RoundResultError";
  }
}
